import { useEffect, useState } from 'react';
import { getParams } from '../utils/params';
import $window from '../utils/window';

export default function useDre20Params() {
  const [params, setParams] = useState({});

  useEffect(() => {
    setParams(getParams($window));
  }, []);

  return params;
}
